var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.069,
    height: 29.279,
    viewBox: "0 0 44.069 29.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#0089c3}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11830",
    transform: "translate(-364.044 -111.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11092",
    transform: "translate(371.117 111.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11086",
    transform: "translate(15.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25684",
    d: "M401.191 119.321v-7.961H387.48v7.961zm-3.1-5.307h.884v3.538h-.884zm0 0",
    className: "cls-1",
    transform: "translate(-387.48 -111.36)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11087",
    transform: "translate(15.079 8.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25685",
    d: "M387.48 120.718v19.46h13.711v-19.46zm11.5 5.307h-.884v-3.98h.884zm0 0",
    className: "cls-1",
    transform: "translate(-387.48 -120.718)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11091",
    transform: "translate(0 13.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25686",
    d: "M384.434 126h-11.348a1.561 1.561 0 0 0-1.559 1.559v2.073h14.466v-2.072a1.56 1.56 0 0 0-1.559-1.56zm-9.46 2.115a.424.424 0 0 1-.6-.6.424.424 0 0 1 .6 0 .422.422 0 0 1 0 .6zm2.724 0a.424.424 0 1 1 .124-.3.427.427 0 0 1-.124.3zm2.723 0a.422.422 0 1 1 .125-.3.424.424 0 0 1-.125.3zm2.724 0a.428.428 0 0 1-.3.125.424.424 0 0 1 0-.848.424.424 0 0 1 .3.723zm0 0",
    className: "cls-1",
    transform: "translate(-371.527 -126.001)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11089",
    transform: "translate(2.664 6.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25687",
    d: "M383.485 133.109h-9.14v5.508h9.14zm-1.392 1.816h-6.355a.423.423 0 1 1 0-.847h6.355a.423.423 0 1 1 0 .847zm0 0",
    className: "cls-1",
    transform: "translate(-374.345 -133.109)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11090",
    transform: "translate(0 4.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25688",
    d: "M371.527 139.168a1.56 1.56 0 0 0 1.559 1.559h11.349a1.56 1.56 0 0 0 1.559-1.559v-8.428h-14.467zm1.816-6.612a.424.424 0 0 1 .424-.423h9.986a.423.423 0 0 1 .423.423v6.355a.424.424 0 0 1-.423.424h-9.986a.424.424 0 0 1-.424-.424zm0 0",
    className: "cls-1",
    transform: "translate(-371.527 -130.74)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path_81",
    transform: "translate(364.044 139.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25689",
    fill: "#272727",
    d: "M407.64 142.28h-43.123a.473.473 0 0 1 0-.945h43.123a.473.473 0 1 1 0 .945z",
    transform: "translate(-364.044 -141.335)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.0a270083aeb8b31a4736645db9d578f8.svg";
export { ForwardRef as ReactComponent };